import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { actions as GroupMembers } from 'data/GroupMembers';
import { connect } from 'omni-common-ui';
import classnames from 'classnames';

import CourseViewTable from 'components/CourseViewTable';
import Styles from './style.postcss';
import {
  accessors,
  status,
} from 'data/WritingAssignment';

const statusStyle = {
  [status.NEW]: classnames(Styles.cell_status, Styles.cell_status_new),
  [status.INPROGRESS]: classnames(Styles.cell_status, Styles.cell_status_inprogress),
  [status.COMPLETE]: classnames(Styles.cell_status, Styles.cell_status_complete),
};

const DEFAULT_CELL = '-';
const movementLimit = 20;

const wasLeftMouseButtonPressed = (e = window.event) => {
  const button = e.which || e.button;
  return button === 1;
};

class SpinListView extends PureComponent {
  constructor(props) {
    super(props);
    this._renderCell = this._renderCell.bind(this);
  }

  _onMouseDown(e) {
    if (! wasLeftMouseButtonPressed(e.nativeEvent)) return;
    this._startMouseX = e.screenX;
  }

  _onClick(e) {
    const movement = Math.abs(this._startMouseX - e.screenX);
    if (this._startMouseX && movement > movementLimit) {
      // x-axis drag happened; block click
      e.preventDefault();
      return false;
    }
  }

  _renderCell(member, spinActivity) {
    if (! member || ! spinActivity || ! spinActivity.studentActivities) return DEFAULT_CELL;
    const studentActivity = spinActivity.studentActivities.get(member.studentGeneralInfo.id);
    if (! studentActivity) return DEFAULT_CELL;
    return <Link className={Styles.cell}
        onMouseDown={(e) => this._onMouseDown(e)}
        onClick={(e) => this._onClick(e)}
        to={this._getDetailURL(studentActivity, studentActivity.activityId)}>
      <div className={Styles.cell_label}>
        {accessors.formatActivityType(studentActivity.activityType)}
      </div>
      <div className={statusStyle[studentActivity.status]}>
        {studentActivity.statusDisplayName}
      </div>
    </Link>;
  }

  _getDetailURL(studentActivity, activityId) {
    const { groupId, buildRoute } = this.props;
    const { studentId } = studentActivity;
    const url = `/group/${groupId}/writing-assignment/activity/${activityId}/student/${studentId}`;
    return buildRoute(url);
  }

  _renderTableHeader(spinWritingAssignmentList = []) {
    return <CourseViewTable.Header>
      <CourseViewTable.Row>
        {
          spinWritingAssignmentList.map((spinActivity) =>
            <CourseViewTable.Cell columnId={spinActivity} small>
              {spinActivity.examType}
            </CourseViewTable.Cell>)
        }
      </CourseViewTable.Row>
    </CourseViewTable.Header>;
  }

  render() {
    const { members, spinWritingAssignmentList } = this.props;
    if (! members) return null;
    return <CourseViewTable students={members}>
      {this._renderTableHeader(spinWritingAssignmentList)}
      <CourseViewTable.Body>
        {this._renderCell}
      </CourseViewTable.Body>
    </CourseViewTable>;
  }
}

SpinListView.propTypes = {
  groupId: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired,
  spinWritingAssignmentList: PropTypes.object,
  buildRoute: PropTypes.func,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const spinWritingAssignmentList = accessors.getSPINWritingAssignment(state, groupId);
  return {
    members,
    groupId,
    spinWritingAssignmentList,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(GroupMembers, dispatch),
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SpinListView);



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/SpinListView/component.jsx